import React, { forwardRef, useState, useEffect } from "react";
import get from "lodash/get";

import { StyledNumberWrapper } from "./numberField.style";
import { ExternalLabel } from "../common.style";
import GenericInputField, {
  TYPES,
  Label,
} from "../../../../genericInputFields/genericInputField";
import { useFormContext } from "react-hook-form";

const NumberField = forwardRef(
  (
    {
      required,
      placeholder,
      minValue,
      maxValue,
      stepValue,
      name: fieldName,
      label,
      value,
      externalLabel,
      settings = {},
      ...rest
    },
    ref,
  ) => {
    const {
      register,
      formState: { errors },
      getValues,
      setValue,
      watch,
    } = useFormContext();
    const error = get(errors, fieldName);
    const [readOnlyField, setReadOnlyField] = useState(false);
    const { notReadOnlyOn } = settings;

    useEffect(() => {
      if (!notReadOnlyOn || !Array.isArray(notReadOnlyOn)) return;

      const itm = notReadOnlyOn.find(
        (item) => getValues(item.field) !== item.value,
      );

      setReadOnlyField(!!itm);
      if (itm?.setDefault) setValue(fieldName, rest?.default);
    }, [getValues, notReadOnlyOn, fieldName, rest.default, setValue]);

    useEffect(() => {
      if (!notReadOnlyOn) return;

      const { unsubscribe } = watch((value, { name, type }) => {
        if (type !== "change") return;

        const entity = notReadOnlyOn.find((el) => el.field === name);
        if (!entity) return;

        const ro = get(value, entity.field) != entity.value;
        setReadOnlyField(ro);
        if (ro && entity.setDefault) setValue(fieldName, rest?.default);
      });
      return () => unsubscribe();
    }, [watch, notReadOnlyOn, setValue, rest.default, fieldName]);

    return (
      <StyledNumberWrapper ref={ref}>
        {externalLabel && (
          <ExternalLabel>
            <Label required={required}>{externalLabel}</Label>
          </ExternalLabel>
        )}
        <GenericInputField
          type={TYPES.NUMBER_LABELED}
          register={register}
          name={fieldName}
          required={required}
          placeholder={placeholder || " "}
          label={label}
          minValue={minValue}
          maxValue={maxValue}
          stepValue={stepValue}
          error={error}
          value={value}
          readOnly={readOnlyField}
        />
      </StyledNumberWrapper>
    );
  },
);
NumberField.displayName = "NumberField";

export default NumberField;
